import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isMobile, isSafari, isIOS } from 'react-device-detect';
import { Box, Button, DialogActions, Fab, Grid, IconButton, ImageList, ImageListItem, } from '@mui/material';
import { AddPhotoAlternate, Save } from '@mui/icons-material';
import PhotoMaker from 'components/PhotoMaker/PhotoMaker';
import WebCamera from 'components/PhotoMaker/WebCamera';
import { ModalActionProps } from 'models/AutoModals';
import { CarModel } from 'models/StockModel';
import { resizeImage } from 'modules/cars/utils/common';


type PhotoAdderProps = {
    car: CarModel,
} & ModalActionProps<File[]>

const PhotoDialog = ({car, onFinish}: PhotoAdderProps) => {
    const {t} = useTranslation('cars');
    const [photos, setPhotos] = useState<File[]>([]);

    const save = () => {
        if (!photos.length)
            return;

        onFinish(photos);
    };

    return (
        <>
            <Grid container textAlign="center">
                <Grid item xs={6}>{car.make} {car.model}</Grid>
                <Grid item xs={6}>{car.chassisNumber}</Grid>
            </Grid>

            <AppPhotoButtons
                addPhotos={setPhotos}
            />

            <Album items={photos}/>

            {isMobile ? (
                <Fab
                    color="primary"
                    aria-label="upload photos"
                    sx={{
                        position: "fixed",
                        bottom: theme => theme.spacing(2),
                        right: theme => theme.spacing(2)
                    }}
                    onClick={save}
                >
                    <Save/>
                </Fab>
            ) : (
                <DialogActions>
                    <Button onClick={save}>{t('upload')}</Button>
                </DialogActions>
            )}
        </>
    );
}


type AlbumProps = {
    items: File[],
}

const Album = ({items}: AlbumProps) => {
    return (
        <ImageList variant="masonry" cols={4}>
            {items.map((p, i) => (
                <ImageListItem key={i}>
                    <img src={URL.createObjectURL(p)} alt=""/>
                </ImageListItem>
            ))}
        </ImageList>
    )
};

type PhotoButtonProps = {
    addPhotos: (photos: File[]) => void,
}

const AppPhotoButtons = ({addPhotos}: PhotoButtonProps) => {
    return (
        <Box textAlign="center">
            <IconButton
                color="primary"
                aria-label="upload picture"
                component="label"
                size="large"
            >
                <input
                    hidden
                    accept="image/*"
                    type="file"
                    multiple
                    onChange={e => {
                        if (!e.target.files)
                            return;

                        Promise.all(Array.from(e.target.files).map(resizeImage)).then(addPhotos);

                        e.target.value = '';
                    }}
                />
                <AddPhotoAlternate fontSize="large"/>
            </IconButton>
            {' '}
            {(!isIOS || isSafari) && <PhotoMaker onFinish={file => addPhotos([file])} inline/>}
            {(!isIOS || isSafari) && <WebCamera onFinish={file => addPhotos([file])} inline/>}
        </Box>
    )
};

export default PhotoDialog;
